import classNames from 'classnames';
import { IModuleConfig } from 'redux-state/layout/types.modules.js';

export const getModulesMetaData = (sectionName: string, moduleConfigArr: IModuleConfig[] | undefined = []) =>
  classNames(sectionName, moduleConfigArr?.map((a) => a.name).join(' '));
